import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* pub3Confirm(action) {
  var payload = {
    action: "portal/pub3Confirm",
    id: action.id,
    channel: action.channel,
  };

  yield put(serverRequest(payload));
}

export default pub3Confirm;
